import { Button, CircularProgress, Alert, Box } from "@mui/material";
import { useSelector } from "react-redux";
import { createAwsStateAndNavigateToAws, verifyAwsAuthorizationComplete } from "../Helper/AppApprovalHelper";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import OnboardingLayout from "../Layout/OnboardingLayout";
import { useTranslation } from "react-i18next";

const AppApprovalForm = () => {
    const { t } = useTranslation("appApproval");
    const navigate = useNavigate();
    const defaultAccount = useSelector((state: any) => state.account.default_account);
    const isPartnerLoggedIn = useSelector((state: any) => state.partner.isPartnerLoggedIn);
    const [isVerifying, setIsVerifying] = useState(false);
    const [verificationError, setVerificationError] = useState<string | null>(null);

    const handleAuthorize = () => {
        if (!defaultAccount?.id) {
            setVerificationError(t("errors.noAccount"));
            return;
        }
        setVerificationError(null);
        createAwsStateAndNavigateToAws(defaultAccount.id, isPartnerLoggedIn);
    };
    const handleVerifyAuthorization = async () => {
        if (!defaultAccount?.id) {
            setVerificationError(t("errors.noAccountForVerification"));
            return;
        }
        try {
            setIsVerifying(true);
            setVerificationError(null);

            await verifyAwsAuthorizationComplete(defaultAccount.id);
            navigate('/layout');

        } catch (error) {
            const errorMsg = error instanceof Error ? error.message : t("errors.verificationFailed");
            setVerificationError(errorMsg);
        } finally {
            setIsVerifying(false);
        }
    };

    return (
        <OnboardingLayout rightClassName="text-center pr-3 pl-3 pb-2 m-auto f-18">

            <h2>{t("title")}</h2>
            <p>{t("subtitle")}</p>
            <p>{t("description")}</p>
            <p>{t("instruction")}</p>
            {verificationError && (
                <Box mb={3}>
                    <Alert severity="error">{verificationError}</Alert>
                </Box>
            )}
            <Box display="flex" gap={2} justifyContent="center" flexWrap="wrap">
                <Button
                    className='button-login h-40p w-200p'
                    onClick={handleAuthorize}
                    disabled={isVerifying}
                >  {t("buttons.authorize")} </Button>

                {isPartnerLoggedIn && (
                    <Button
                        className='button-login h-40p w-200p'
                        onClick={handleVerifyAuthorization}
                        disabled={isVerifying}
                        variant={isVerifying ? "outlined" : "contained"}
                        startIcon={isVerifying ? <CircularProgress size={20} /> : null}
                    >
                        {isVerifying ? t("buttons.verifying") : t("buttons.completed")}
                    </Button>
                )}
            </Box>

            {isPartnerLoggedIn && (
                <Box mt={3} sx={{ fontSize: "0.9rem", color: "#666" }}>
                    <p>{t("footerNote")}</p>
                </Box>
            )}
        </OnboardingLayout>
    );
};

export default AppApprovalForm;